import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Nfc as NfcIcon } from '@mui/icons-material';

import { MenuItem } from 'types/global';

type Props = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function NfcCards({ selected, onSelect, open }: Props) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/nfc-cards"
			selected={selected === MenuItem.NfcCards}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.NfcCards)}
		>
			<ListItemIcon>
				<NfcIcon />
			</ListItemIcon>
			{open && <ListItemText primary={t('nfc:nfcCards')} />}
		</ListItem>
	);
}
